import React from 'react';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import { Container } from 'semantic-ui-react';
import { PageActions } from 'iovisit-theme/components/Views';
import { PageActionsExternalLink } from 'iovisit-museum-theme/components/Views';

const PageHeaderText = ({
  content,
  showShareLinks = false,
  showDownloadApp = false,
}) => {
  return (
    <Plug pluggable="leadimage-more" id="page-header">
      {(params) => {
        return (
          <Container>
            <div className="leadimage-more-content">
              {params.content?.title && (
                <h1 className="title">{params.content?.title}</h1>
              )}
              {params.content?.description && (
                <div className="description">{params.content?.description}</div>
              )}
              {showShareLinks ? (
                <PageActions
                  content={params.content}
                  showBookmark={true}
                  showLabel={true}
                  className="leadimage-links"
                />
              ) : (
                <PageActionsExternalLink
                  content={params.content}
                  showDownloadApp={showDownloadApp}
                  className="leadimage-links"
                />
              )}
            </div>
          </Container>
        );
      }}
    </Plug>
  );
};

export default PageHeaderText;
